var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoopEnd = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 88,
    viewBox: "0 0 59 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 40C59 17.9086 41.0914 0 19 0H7C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14H7.5C11.6421 14 15 17.3579 15 21.5V52.5C15 56.6421 11.6421 60 7.5 60C3.35786 60 0 63.3579 0 67.5V78C0 83.5229 4.47715 88 10 88H15H19C41.0914 88 59 70.0914 59 48V40Z",
    fill: "#C4C4C4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoopEnd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LoopEnd.7f0ee2339cdce751a5e5b02c23deefda.svg";